<div class="half-page-logo">
  <img alt="" src="./assets/img/logo.svg" />
  <h2 class="title-logo">
    <span>Outil Cantonal de</span>
    <span>Statistiques des déchets</span>
  </h2>
</div>
